import './index.css';
import classnames from 'classnames'
import React, { PureComponent, createRef } from "react"
import config from "config/default"

const { cdnUrl } = config

/**
 * 加载网络图片
 */
export default class NETImage extends PureComponent {
    observer = undefined
    rootRef = createRef()

    state = {
        loading: true,
        cropOption: 'cropWidth',
        isInViewport: IntersectionObserver ? false : true,
    }

    onSuccess = evt => {
        const {
            imgClassname,
            useAutoHeight,
        } = this.props

        const {
            parentElement: {
                clientWidth,
                clientHeight,
            },
            naturalWidth,
            naturalHeight,
        } = evt.currentTarget
        const viewportWH = clientWidth / clientHeight
        const imageWH = naturalWidth / naturalHeight

        if (!imgClassname) {
            if (imageWH < viewportWH) {
                // 长图使用居中、上下剪裁
                this.setState({
                    cropOption: 'cropHeight'
                })
            } else {
                // 宽图使用居中、左右剪裁
                this.setState({
                    cropOption: 'cropWidth'
                })
            }
        }

        if (useAutoHeight) {
            const imageViewHeight = naturalHeight * (clientWidth / naturalWidth)
            this.setState({
                autoHeight: imageViewHeight,
            })
        }

        setTimeout(() => {
            this.setState({
                loading: false
            })
        }, 250)
    }

    get containerClassname() {
        const { className } = this.props

        return classnames('net-image__container', className)
    }

    get imgClassname() {
        const { imgClassname } = this.props
        const { cropOption } = this.state

        return classnames(
            {
                'absolute-fill': !imgClassname,
                'crop-width': !imgClassname && cropOption === 'cropWidth',
                'crop-height': !imgClassname && cropOption === 'cropHeight',
            },
            imgClassname
        )
    }

    get placeholderClassname() {
        const { loading } = this.state

        return classnames(
            'absolute-fill',
            'net-image__placeholder',
            {
                'net-image__placeholder--faded': !loading,
            }
        )
    }

    get contentClassname() {
        const { contentClassname } = this.props

        return classnames(
            'absolute-fill',
            contentClassname,
        )
    }

    get containerStyle() {
        const { useAutoHeight } = this.props
        return useAutoHeight ?
            {
                overflow: 'visible',
            } : {}
    }

    get imgUrl() {
        const {
            src,
            /**
             * 这里是线上图片存储的根目录，一般不需要改
             */
            origin = cdnUrl,
            /**
             * 这里可以填课程、课程主题的前缀，例如/fjys表示风景艺术
             */
            prefix = '',
        } = this.props

        return origin + '/' + prefix + src
    }

    onImageClick = () => {
        const { usePreview = false, onClick } = this.props
        if (usePreview) {
            window.wx.previewImage({
                current: this.imgUrl,
                urls: [this.imgUrl]
            })
        } else {
            onClick && onClick()
        }
    }

    render() {
        const {
            children,
            /**
             * 刚开始时的展示高度
             */
            startHeight = 128,
            /**
             * 该变量用于控制relative元素高度是否跟随图片变化，撑大父容器，以此达到高度自动的目的
             */
            useAutoHeight = false,
            needPlaceholder = true,
            styles = {},
        } = this.props

        const {
            autoHeight = 0,
            isInViewport,
        } = this.state;

        return (
            <div
                ref={this.rootRef}
                onClick={this.onImageClick}
                className={this.containerClassname}
                style={{ ...this.containerStyle, ...styles }}
            >
                {
                    useAutoHeight && <div className='net-image__auto-height' style={{ height: autoHeight || startHeight }} />
                }
                {
                    isInViewport &&
                    <img
                        alt='shm'
                        src={this.imgUrl}
                        onLoad={this.onSuccess}
                        className={this.imgClassname}
                    />
                }
                {
                    needPlaceholder && <div className={this.placeholderClassname} />
                }
                <div className={this.contentClassname}>
                    {children}
                </div>
            </div>
        )
    }

    componentDidMount() {
        if (IntersectionObserver && this.rootRef.current) {
            this.observer = new IntersectionObserver(
                entries => {
                    entries.forEach(entry => {
                        if ((entry.intersectionRatio > 0 || entry.isIntersecting)) {
                            // 出现在视图中
                            this.setState({
                                isInViewport: true,
                            })
                            this.observer.unobserve(this.rootRef.current)
                        }
                    })
                },
                {
                    threshold: 0.01,
                    rootMargin: "75%",
                }
            )
            this.observer.observe(this.rootRef.current)
        }
    }

    componentWillUnmount() {
        if (this.observer && this.observer.unobserve) {
            this.observer.unobserve(this.rootRef.current)
        }
    }
}